/******************************** Import Package ************************************/
import React from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";

/******************************** Input ************************************/
export default function Input(props) {
  const { name, label, value, error = null, onChange, amount, ...other } = props;

  return (
    <TextField
      variant="outlined"
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      InputProps={{
        startAdornment: amount ? (
          <InputAdornment position="start">$</InputAdornment>
        ) : null,
      }}
      {...other}
      error={Boolean(error)}
      helperText={error}
    />
  );
}
